<div class="apply-changes-recursively-question-modal">
  <h2 mat-dialog-title>
    {{ title | translate }}
  </h2>
  <form [formGroup]="formGroup" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <mat-radio-group class="vertical-radio-group" formControlName="editType">
        @for (editType of [EItemEditType.onlyThis, EItemEditType.thisAndFollowing, EItemEditType.all]; track editType) {
          <mat-radio-button [value]="EItemEditType[editType]">{{
            'page.items.applyChangesRecursivelyQuestionModal.choice.' + editType | translate
          }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ 'button.save' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
